export default "__VITE_ASSET__Cqv$vwR5__"